import { getExperimentMeasurementsFromMapping } from "./getExperimentMeasurementsFromMapping";
import getExperimentParametersFromMapping from "./getExperimentParametersFromMapping";
import type { DatapointCreateInput, DatasetCreateInput } from "@globals";
import type { ColumnMapping } from "@lib/dataset/Mapping/types";
import { ContextualError } from "@lib/utils/ContextualError";

function getDatapointsFromMapping(mappings: ColumnMapping[]): DatapointCreateInput[] {
  if (mappings.length === 0) {
    return [];
  }

  const parameterMappings = mappings.filter(item => !item.disabled && item.type === "parameter" && item.datapoints);
  const measurementMappings = mappings.filter(item => !item.disabled && item.type === "measurement" && item.datapoints);

  // Assuming all mappings have the same number of datapoints

  if (!mappings[0].datapoints) {
    throw new ContextualError("First mapping is missing datapoints", {
      first_mapping: mappings[0]
    });
  }
  const numDatapoints = mappings[0].datapoints.length;

  return Array.from({ length: numDatapoints }, (_, index) => ({
    parameter_values: parameterMappings.map(mapping => {
      if (!mapping.datapoints) {
        throw new ContextualError("Parameter mapping is missing datapoints", { mapping });
      }
      return {
        parameter_id: mapping.id,
        executed_text_value: mapping.isCategorical ? String(mapping.datapoints[index]) : null,
        executed_numerical_value: mapping.isCategorical ? null : Number(mapping.datapoints[index])
      };
    }),
    measurement_values: measurementMappings.map(mapping => {
      if (!mapping.datapoints) {
        throw new ContextualError("Measurement mapping is missing datapoints", { mapping });
      }
      return {
        measurement_id: mapping.id,
        value: Number(mapping.datapoints[index])
      };
    })
  }));
}

export default function getDatasetFromMapping(mappings: ColumnMapping[], datasetName: string): DatasetCreateInput {
  const parameters = getExperimentParametersFromMapping(mappings);
  const measurements = getExperimentMeasurementsFromMapping(mappings);
  const datapoints = getDatapointsFromMapping(mappings);

  return {
    name: datasetName,
    datapoints,
    parameters,
    measurements
  };
}
